/* eslint-disable no-console */
import { send } from "@utils/fetch";
import { captureException } from "@utils/error";
import { NoomError } from "../error/NoomError";

const createPostRequest = (url: string, requestBody: JsonObject) => {
  return send("POST", url, requestBody);
};

const apiCreateVisit = async (requestBody: JsonObject) => {
  return createPostRequest(`/visit/v1/create/`, requestBody)
    .then((text: string) => {
      console.log(`${text}! User Id: ${requestBody.id} `);
    })
    .catch((e: any) => {
      console.log("Visit creation failed", e);
      captureException(new NoomError("Visit creation failed", { cause: e }));
    });
};

const apiUpdateVisit = async (requestBody: JsonObject) => {
  return createPostRequest(`/visit/v1/update/`, requestBody)
    .then((text: string) => {
      console.log(`${text}! User Id: ${requestBody.id} `);
    })
    .catch((e: any) => {
      console.log("Visit update failed", e);
      captureException(new NoomError("Visit update failed", { cause: e }));
    });
};

export { apiCreateVisit, apiUpdateVisit };
